import MBS from './MBS.pdf';
import MBK from './MBK.pdf';

export const termsAndConditionsPDF = {
    MBS,
    MBK,
};
